module.exports = __webpack_public_path__ + "img/186.1ac067b6.jpg";